import { render, staticRenderFns } from "./FirstBankView.vue?vue&type=template&id=71b0f7be&scoped=true&"
import script from "./FirstBankView.vue?vue&type=script&lang=js&"
export * from "./FirstBankView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0f7be",
  null
  
)

export default component.exports